import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";

import ForgotPasswordForm from "./ForgotPasswordForm";

const ForgotPasswordModal = ({
	show,
	onHide
}) => (
	<Modal centered onHide={onHide} show={show} size="lg">
		<Modal.Header className="px-5 py-3" closeButton>
			<Modal.Title className="text-secondary fs-20">
				Password Recovery
			</Modal.Title>
		</Modal.Header>

		<Modal.Body className="px-5 py-4">
			<ForgotPasswordForm onCancel={onHide} />
		</Modal.Body>
	</Modal>
);

ForgotPasswordModal.propTypes = {
	onHide: PropTypes.func.isRequired,
	show: PropTypes.bool
};

ForgotPasswordModal.defaultProps = {
	show: false
};

export default ForgotPasswordModal;
